export default "__VITE_ASSET__DqFN_CxP__"